import { Package, Clock, CheckCircle, AlertCircle, Repeat } from 'lucide-react';
import type { OrderStatus } from '@paulownia/shared/types';

interface OrderStatusCardProps {
  orderId: string;
  tenantName: string;
  tenantSlug: string;
  status: OrderStatus;
  pickupTime?: string;
  isRecurring?: boolean;
  onClick: () => void;
}

const statusConfig: Record<OrderStatus, {
  label: string;
  icon: typeof Clock;
  bgColor: string;
  textColor: string;
}> = {
  awaiting_validation: {
    label: 'En attente',
    icon: AlertCircle,
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-800',
  },
  pending: {
    label: 'Confirmée',
    icon: CheckCircle,
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-800',
  },
  ready: {
    label: 'Prête',
    icon: CheckCircle,
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
  },
  done: {
    label: 'Terminée',
    icon: Package,
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-800',
  },
};

export function OrderStatusCard({
  tenantName,
  status,
  pickupTime,
  isRecurring,
  onClick,
}: OrderStatusCardProps) {
  const config = statusConfig[status] || statusConfig.pending;
  const Icon = config.icon;

  return (
    <button
      onClick={onClick}
      className="w-full p-4 bg-white rounded-lg border border-gray-200 hover:border-orange-300 hover:shadow-sm transition-all text-left"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5">
            <p className="font-medium text-gray-900 truncate">{tenantName}</p>
            {isRecurring && (
              <span title="Commande récurrente"><Repeat className="w-3.5 h-3.5 text-orange-500 flex-shrink-0" /></span>
            )}
          </div>
          {pickupTime && (
            <p className="text-sm text-gray-500">Retrait : {pickupTime}</p>
          )}
        </div>
        <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full ${config.bgColor}`}>
          <Icon className={`w-4 h-4 ${config.textColor}`} />
          <span className={`text-xs font-medium ${config.textColor}`}>
            {config.label}
          </span>
        </div>
      </div>
    </button>
  );
}
